import request from "@/utils/request";

export default function getHsitoryMessages() {
    return request({
        url: `/chatLog/getNotReadMessage`,
        method: 'get',
    })
}